import { Button, Tooltip } from '@lightbeamai/design-system'
import React, { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { ArrowLeft, ArrowRight } from 'phosphor-react'

export interface FlowControlProps {
  isEdit?: boolean
  backButtonProps: {
    onClick: () => void
    disabled: boolean
    visible?: boolean
    label?: string
  }
  nextButtonProps: {
    onClick: () => void
    disabled: boolean
    label?: string
    showIcon?: boolean
    visible?: boolean
    isLoading?: boolean
    tooltip?: string
  }
  showCancelButton: boolean
  showConfirmCancel: () => void
  onCancel?: () => void
  isLastStep: boolean
  isFirstStep: boolean
  confirmCancelContent?: ReactNode
  confirmCancelHeaderKey?: string
  cancelConfirmButtonText?: string
  cancelCancelButtonText?: string
  cancelButtonLabelText?: string
}

const FlowControl = (props: FlowControlProps) => {
  const {
    backButtonProps,
    nextButtonProps,
    showCancelButton,
    isEdit,
    showConfirmCancel,
    isLastStep,
    isFirstStep,
    cancelButtonLabelText
  } = props

  const nextBtnLabel = isLastStep ? 'btn.saveAndClose' : 'btn.next'
  const cancelBtnLabel = isEdit ? 'btn.close' : 'btn.cancel'

  const onBackClick = () => {
    if (isFirstStep) {
      showConfirmCancel()
    } else {
      backButtonProps.onClick()
    }
  }

  const showBackButton =
    !isFirstStep && (backButtonProps.visible !== undefined ? backButtonProps.visible : true)

  return (
    <div className="flow-control-wrapper">
      <div className="flow-control-back-btn">
        {showBackButton && (
          <Button
            variant="secondary"
            size={32}
            icon={<ArrowLeft />}
            htmlType="button"
            onClick={onBackClick}
          >
            {backButtonProps.label || <FormattedMessage id="btn.back" />}
          </Button>
        )}
      </div>
      <div className="flow-control-actions">
        {showCancelButton && (
          <Button variant="secondary" size={32} htmlType="button" onClick={showConfirmCancel}>
            <FormattedMessage id={cancelButtonLabelText || cancelBtnLabel} />
          </Button>
        )}
        <Tooltip title={nextButtonProps?.tooltip || ''}>
          <Button
            variant="primary"
            size={32}
            iconPosition="right"
            onClick={nextButtonProps.onClick}
            icon={!nextButtonProps.showIcon ? undefined : isLastStep ? undefined : <ArrowRight />}
            disabled={nextButtonProps.disabled || nextButtonProps.isLoading}
            loading={nextButtonProps.isLoading}
          >
            {nextButtonProps.label || <FormattedMessage id={nextBtnLabel} />}
          </Button>
        </Tooltip>
      </div>
    </div>
  )
}

export default FlowControl
